export type ToastKind = 'error' | 'success' | 'warning' | 'info';

export interface ToastEvent {
  kind: ToastKind;
  title: string;
  message: string;
}

export const emitToast = (toast: ToastEvent) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<ToastEvent>('crm4chef:toast', { detail: toast }));
};
